// extracted by mini-css-extract-plugin
module.exports = {"root":"TipList-module--root--IinIP"};